/* Newsletter signup (Eli, 2026-09-16 and 17).
   Signups go straight to Klaviyo's client subscriptions API, list "Email List", which starts the
   welcome email with the unique FJBC100 code; Klaviyo syncs the subscriber back to Shopify. With
   JavaScript off the form still posts to Shopify's customer form, and Shopify's own sync adds the
   subscriber to the same list.
   On success the email box shows "Check your email" and the small print asks the subscriber to
   confirm by email. Both stay until the visitor types in the box or clicks it (Eli, 2026-10-13:
   with the confirm step, that instruction must not disappear on a timer; it replaced the 8-second
   reset of 2026-09-16). Errors keep the typed address. No popup, no page reload.
   Bot guard: a hidden field people never see, or a submit with no interaction with the form.
   Either one is treated as a bot: the page shows normal success and nothing is sent,
   so a bot learns nothing. */
(function () {
  var REQUEST_TIMEOUT_MS = 15000;
  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;
  var KLAVIYO_REVISION = '2026-07-15';

  function sendToKlaviyo(form, email) {
    var company = form.getAttribute('data-klaviyo-company');
    var list = form.getAttribute('data-klaviyo-list');
    return new Promise(function (resolve, reject) {
      var controller = new AbortController();
      var timeout = setTimeout(function () {
        var error = new Error('Subscription response timed out');
        error.uncertain = true;
        reject(error);
        controller.abort();
      }, REQUEST_TIMEOUT_MS);
      // Settling this promise once also prevents a late response from changing a retry's UI.
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'FJBC website newsletter',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (response) {
        clearTimeout(timeout);
        if (response.ok) { resolve(); return; }
        var error = new Error('Klaviyo responded ' + response.status);
        error.status = response.status;
        reject(error);
      }, function () {
        clearTimeout(timeout);
        // A lost response does not establish whether the provider accepted the request.
        var error = new Error('Subscription response unavailable');
        error.uncertain = true;
        reject(error);
      });
    });
  }

  function init(form) {
    if (form.getAttribute('data-nl-ready')) return;
    form.setAttribute('data-nl-ready', 'true');

    var input = form.querySelector('[data-nl-input]');
    var button = form.querySelector('[data-nl-btn]');
    var done = form.querySelector('[data-nl-done]');
    var fine = form.querySelector('[data-nl-fine]');
    var status = form.querySelector('[data-nl-status]');
    var trap = form.querySelector('[data-nl-hp]');
    if (!input || !button || !done || !fine || !status) return;

    var state = 'idle';
    var touched = false;

    form.noValidate = true;

    ['focusin', 'input', 'pointerdown', 'keydown'].forEach(function (type) {
      form.addEventListener(type, function () { touched = true; }, { passive: true });
    });

    function setState(name) {
      state = name;
      if (name === 'idle') form.removeAttribute('data-state');
      else form.setAttribute('data-state', name);
    }

    function showMessage(name) {
      fine.setAttribute('data-show', name);
      input.setAttribute('aria-describedby', 'nl-fine-' + name);
    }

    function reset() {
      input.readOnly = false;
      input.removeAttribute('aria-invalid');
      status.textContent = '';
      showMessage('default');
      setState('idle');
    }

    function succeed() {
      input.value = '';
      input.readOnly = true;
      input.removeAttribute('aria-invalid');
      button.removeAttribute('aria-disabled');
      showMessage('thanks');
      setState('done');
      status.textContent = fine.querySelector('[data-msg="thanks"]').textContent;
    }

    function fail(kind) {
      input.readOnly = false;
      if (kind === 'invalid') input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      button.removeAttribute('aria-disabled');
      showMessage(kind);
      setState('error');
      input.focus();
      status.textContent = fine.querySelector('[data-msg="' + kind + '"]').textContent;
    }

    function looksLikeABot() {
      if (trap && trap.value) return true;
      return !touched;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (state === 'sending' || state === 'done') return;
      var email = input.value.trim();
      if (!EMAIL.test(email)) {
        fail('invalid');
        return;
      }
      input.readOnly = true;
      button.setAttribute('aria-disabled', 'true');
      setState('sending');
      status.textContent = '';
      if (looksLikeABot()) {
        setTimeout(succeed, 900);
        return;
      }
      sendToKlaviyo(form, email).then(succeed, function (error) {
        fail(error && error.uncertain ? 'unknown' : error && error.status === 400 ? 'invalid' : 'failed');
      });
    });

    input.addEventListener('input', function () {
      if (state !== 'error') return;
      input.removeAttribute('aria-invalid');
      status.textContent = '';
      showMessage('default');
      setState('idle');
    });

    /* During the success state the box is read-only; a key or a click there hands it back. */
    input.addEventListener('keydown', function (event) {
      if (state !== 'done' || event.key === 'Tab' || event.key === 'Enter' || event.key === 'Shift') return;
      reset();
    });
    done.addEventListener('pointerdown', function (event) {
      if (state !== 'done') return;
      event.preventDefault();
      reset();
      input.focus();
    });

    /* Shopify also renders posted_successfully? from customer_posted in the URL.
       In this JavaScript path, only our own accepted request may show success.
       Without JavaScript, Shopify's native return message remains the fallback. */
    if (fine.getAttribute('data-show') === 'thanks') reset();
  }

  function start() {
    document.querySelectorAll('[data-nl-form]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
